import './dropdown.css';

import { type JSX, PureComponent } from 'react';
import ReactDropdown, { type Option } from 'react-dropdown';

interface Props {
  baseClassName?: string;
  name: string;
  onChange: (value: string) => void;
  onChangeType?: string;
  options: Option[];
  value: string;
}

export class Dropdown extends PureComponent<Props> {
  static whyDidYouRender = true;

  handleChange = ({ value }: Option): void => {
    this.props.onChange(value);
  };

  render(): JSX.Element {
    return <ReactDropdown {...this.props} onChange={this.handleChange} />;
  }
}
